var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "16", viewBox: "0 0 20 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.29.176c.399.02.726.322.777.719l1.344 10.428.433-1.298a.825.825 0 0 1 .783-.563H19a.825.825 0 1 1 0 1.65h-2.779l-1.386 4.15a.825.825 0 0 1-1.6-.157l-1.217-9.439-1.242 5.38a.825.825 0 0 1-1.455.32L7.736 9.328l-1.204 1.48a.825.825 0 0 1-.64.304H1a.825.825 0 0 1 0-1.65h4.5l1.611-1.98a.825.825 0 0 1 1.292.014l1.156 1.488 1.886-8.17a.825.825 0 0 1 .845-.638z", fill: "#142A39" })
  );
});